import FormControlLabel from '@mui/material/FormControlLabel';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import {useTranslation} from "react-i18next";
import Toolbar from '@mui/material/Toolbar';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Grid from '@mui/material/Grid';
import {observer} from 'mobx-react';
import React from 'react';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {COMM_OK} from '../WsR2.js';

const MediaDialog = observer((props) => {
	const {isOpen, handleClose, mediaPos} = props;
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	function captionChanged(ev) {
		if (gStorage.conn.online && (gStorage.taxons.editMedia.user_id === gStorage.conn.user.id || gStorage.conn.user._access))
			gStorage.taxons.setEditMedia({...gStorage.taxons.editMedia, caption: ev.target.value});
	}

	function descriptionChanged(ev) {
		if (gStorage.conn.online && (gStorage.taxons.editMedia.user_id === gStorage.conn.user.id || gStorage.conn.user._access))
			gStorage.taxons.setEditMedia({...gStorage.taxons.editMedia, desc: ev.target.value});
	}

	function copyrightChanged(ev) {
		if (gStorage.conn.online && (gStorage.taxons.editMedia.user_id === gStorage.conn.user.id || gStorage.conn.user._access))
			gStorage.taxons.setEditMedia({...gStorage.taxons.editMedia, copyright: ev.target.value});
	}

	function publicChanged(ev, value) {
		if (gStorage.conn.online && (gStorage.taxons.editMedia.user_id === gStorage.conn.user.id || gStorage.conn.user._access))
			gStorage.taxons.setEditMedia({...gStorage.taxons.editMedia, public: value ? 1 : 0});
	}

	function mediaDialogRxWs(status, msg) {
		if (status !== COMM_OK || msg.result !== 'OK') {
			console.error('mediaDialogRxWs: error ', status, msg);
			return -1;
		}

		if (msg.cmd === 'file' && msg.op === 'save_props') {
			console.log('save done!');
			gStorage.taxons.editMediaToMediaList(mediaPos);
			handleClose(true);
		} else {
			console.error('mediaDialogRxWs: unknown command', msg.cmd, msg.op);
		}
	}
	
	function saveMediaProps(ev) {
// 		console.log('saveMediaProps', mediaPos);

		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'file',
			op: 'save_props',
			data: {
				file: gStorage.taxons.editMedia
			}
		};

		gStorage.conn.ws.send(msg, mediaDialogRxWs);
	}

	if (!gStorage.taxons.editMedia || !gStorage.taxons.mediaList || mediaPos < 0 || mediaPos >= gStorage.taxons.mediaList.length)
		return null;

	return (
        	<Dialog aria-labelledby="media-dialog" open={isOpen ? true : false} PaperProps={{sx: {margin: 0, padding: 0}}}>
			<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0} style={{width:316}}>
				<AppBar position="sticky">
					<Toolbar variant="dense">
						<Typography variant="h6" style={{flexGrow: 1, textAlign: 'center'}}>{t('media.properties')}</Typography>
						<IconButton 
						    edge="start" 
						    color="inherit" 
						    onClick={() => handleClose(false)}>
							<CloseIcon />
						</IconButton> 
					</Toolbar>
				</AppBar>
				<Typography variant={'h6'}>
					{gStorage.taxons.editMedia.name}
				</Typography>
				<Grid size={{xs: 12}} align={'center'}>
					<TextField 
						label={t('media.caption')}
						variant="outlined"
						value={gStorage.taxons.editMedia.caption}
						onChange={captionChanged}
						multiline rows="4"
						size="small" 
						style={{width: 284, margin: 4}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<TextField 
						label={t('media.copyright')}
						variant="outlined"
						value={gStorage.taxons.editMedia.copyright}
						onChange={copyrightChanged}
						size="small" 
						style={{width: 284, margin: 4}}
						inputProps={{maxLength: 128}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<TextField 
						label={t('media.description')}
						variant="outlined"
						value={gStorage.taxons.editMedia.desc}
						onChange={descriptionChanged}
						multiline rows="4"
						size="small"
						style={{width: 284, margin: 4}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControlLabel
						label={t('media.public')}
						labelPlacement="start"
						checked={!!gStorage.taxons.editMedia.public}
						onChange={publicChanged}
						control={<Checkbox color="primary" />}
						style={{margin: 8}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					{
					((gStorage.taxons.editMedia.user_id === gStorage.conn.user.id || gStorage.conn.user._access) && gStorage.conn.online) ? 
						<Button 
							variant="contained" 
							color="primary" 
							size="small" 
							style={{width:143, margin: 4}} 
							disabled={!gStorage.conn.online || !gStorage.conn.is_auth}
							onClick={saveMediaProps}>
								{t('media.save')}
						</Button> : 
						null
					}
				</Grid>
			</Grid>
		</Dialog>
	);
});

export default MediaDialog;
